module.exports = __webpack_public_path__ + "static/inovatec-logo-ed5eff6dc6bcca52771a7f9878cb933e.jpeg";